// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f63df6df","147":"48198676","295":"4e2577ec","362":"da96d3f5","574":"007418da","807":"713c5f2d","818":"27ad003b","899":"d7c97a3f","900":"bbec8e99","996":"94f91f6c"}[chunkId] + ".chunk.js";
};